<template>
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
    stroke-linejoin="round" width="22" height="22">
    <line x1="12" y1="4" x2="12" y2="15" />
    <circle cx="12" cy="20" r="0.5" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'WarningIcon'
}
</script>
